import { render, staticRenderFns } from "./BatchInvoices.vue?vue&type=template&id=57a4ea28&scoped=true&"
import script from "./BatchInvoices.vue?vue&type=script&lang=js&"
export * from "./BatchInvoices.vue?vue&type=script&lang=js&"
import style0 from "./BatchInvoices.vue?vue&type=style&index=0&id=57a4ea28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4ea28",
  null
  
)

export default component.exports